module.exports = __webpack_public_path__ + "static/june-8-2ee2d85de527f734d331c14815f296d0.png";